import apiClient from "./api";
import { getApiAccessToken } from "./UserService";

export interface ContractSidecostGroupsContractOption {
  id: number;
  name: string;
}

export interface ContractSidecostItem {
  generalSidecostItemId: number;
  sidecostItemId?: number | null;
  itemNumber: number;
  itemSubnumber: number;
  itemCode?: string | null;
  name: string;
  unitName: string;
  unitPrice?: number | null;
  selected: boolean;
  showAltValueField: boolean;
  isInUse: boolean;
}

export interface ContractSidecostGroup {
  id: number;
  name: string;
  orderInGroup: number;
  rowNumber: number;
  items: ContractSidecostItem[];
}

export interface ContractSidecostGroupsResponse {
  hideWorkItemNumber: boolean;
  useWorkItemCode: boolean;
  showWorkItemAreaPerPriceItem: boolean;
  selectedContractId?: number | null;
  hasAnySidecostItems: boolean;
  availableContracts: ContractSidecostGroupsContractOption[];
  groups: ContractSidecostGroup[];
}

export interface SaveContractSidecostGroupsRequest {
  items: ContractSidecostItemSelectionRequest[];
}

export interface ContractSidecostItemSelectionRequest {
  generalSidecostItemId: number;
  unitPrice?: number | null;
  selected: boolean;
  showAltValueField: boolean;
}

async function authHeader(): Promise<Record<string, string>> {
  const token = await getApiAccessToken();
  return { Authorization: `Bearer ${token}` };
}

export const getContractSidecostGroups = async (
  addressSystemId: number,
  contractId?: number | null,
): Promise<ContractSidecostGroupsResponse> => {
  const headers = await authHeader();
  const response = await apiClient.get<ContractSidecostGroupsResponse>(
    `/api/ContractSidecostGroups/${addressSystemId}`,
    {
      headers,
      params: contractId ? { contractId } : undefined,
    },
  );
  return response.data;
};

export const saveContractSidecostGroups = async (
  addressSystemId: number,
  contractId: number,
  request: SaveContractSidecostGroupsRequest,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.put(
    `/api/ContractSidecostGroups/${addressSystemId}/contracts/${contractId}`,
    request,
    { headers },
  );
};

export const copyContractSidecostGroups = async (
  addressSystemId: number,
  contractId: number,
  sourceContractId: number,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.post(
    `/api/ContractSidecostGroups/${addressSystemId}/contracts/${contractId}/copy`,
    { sourceContractId },
    { headers },
  );
};